<div class="wrap">
  <div class="header">
    <div class="logo">
      <app-svg-icon
        [name]="'logo-small'"
        [color]="'color-surface'"
      ></app-svg-icon>
    </div>
    <div class="greeting">{{ "@pages.login.greeting" | translate }}</div>
    <div class="brand">Chill&Bite</div>
  </div>
  <div class="content">
    <div class="title">{{ "@pages.signup.title" | translate }}</div>
    <div class="form">
      <div class="form-item">
        <app-input
          [control]="signupForm.controls.name"
          [iconName]="'user'"
          [label]="'@pages.signup.form.fullname.label' | translate"
          [placeholder]="'@pages.signup.form.fullname.placeholder' | translate"
          [isMarkedAsRequired]="true"
        ></app-input>
        <div
          *ngIf="
            signupForm.controls.name.touched && !signupForm.controls.name.value
          "
          class="input-error-message"
        >
          {{ "@pages.signup.form.errors.nameEmpty" | translate }}
        </div>
      </div>
      <div class="form-item">
        <app-input
          [control]="signupForm.controls.email"
          [iconName]="'email'"
          [label]="'@pages.signup.form.email.label' | translate"
          [placeholder]="'@pages.signup.form.email.placeholder' | translate"
          [isMarkedAsRequired]="true"
          [inputType]="'email'"
        ></app-input>
        <div
          *ngIf="
            signupForm.controls.email.touched &&
            !signupForm.controls.email.value
          "
          class="input-error-message"
        >
          {{ "@pages.signup.form.errors.emailEmpty" | translate }}
        </div>
        <div
          *ngIf="
            !signupForm.controls.email.errors?.['custom'] &&
            signupForm.controls.email.value &&
            signupForm.controls.email.invalid
          "
          class="input-error-message"
        >
          {{ "@pages.signup.form.errors.invalidEmail" | translate }}
        </div>
        <div
          *ngIf="signupForm.controls.email.errors?.['custom']?.['existing']"
          class="input-error-message"
        >
          {{ "@pages.signup.form.errors.existingEmail" | translate }}
        </div>
      </div>
      <div class="form-item">
        <app-input
          [control]="signupForm.controls.pickupHandle"
          [iconName]="'user'"
          [label]="'@pages.login.form.username.label' | translate"
          [placeholder]="'@pages.login.form.username.placeholder' | translate"
          [isMarkedAsRequired]="true"
        ></app-input>
        <div
          *ngIf="
            signupForm.controls.pickupHandle.touched &&
            !signupForm.controls.pickupHandle.value
          "
          class="input-error-message"
        >
          {{ "@pages.signup.form.errors.usernameEmpty" | translate }}
        </div>
        <div
          *ngIf="
            !signupForm.controls.pickupHandle.errors?.['custom'] &&
            signupForm.controls.pickupHandle.value &&
            signupForm.controls.pickupHandle.invalid
          "
          class="input-error-message"
        >
          {{ "@pages.signup.form.errors.usernameInvalid" | translate }}
        </div>
        <div
          *ngIf="signupForm.controls.pickupHandle.errors?.['custom']?.['existing']"
          class="input-error-message"
        >
          {{ "@pages.signup.form.errors.existingUsername" | translate }}
        </div>
      </div>
      <div class="form-item">
        <app-input
          [control]="signupForm.controls.password"
          [iconName]="'lock'"
          [label]="'@pages.login.form.password.label' | translate"
          [placeholder]="'@pages.login.form.password.placeholder' | translate"
          [isMarkedAsRequired]="true"
          [inputType]="'password'"
        ></app-input>
        <div
          *ngIf="
            signupForm.controls.password.touched &&
            !signupForm.controls.password.value
          "
          class="input-error-message"
        >
          {{ "@pages.signup.form.errors.passwordEmpty" | translate }}
        </div>
        <div
          *ngIf="
            signupForm.controls.password.value &&
            signupForm.controls.password.invalid
          "
          class="input-error-message"
        >
          {{ "@pages.signup.form.errors.passwordInvalid" | translate }}
        </div>
      </div>
      <div class="form-item">
        <app-input
          [control]="signupForm.controls.confirmPassword"
          [iconName]="'lock'"
          [label]="'@pages.signup.form.confirmPassword.label' | translate"
          [placeholder]="
            '@pages.signup.form.confirmPassword.placeholder' | translate
          "
          [isMarkedAsRequired]="true"
          [inputType]="'password'"
        ></app-input>
        <div
          *ngIf="
            signupForm.controls.confirmPassword.touched &&
            !signupForm.controls.confirmPassword.value
          "
          class="input-error-message"
        >
          {{ "@pages.signup.form.errors.passwordEmpty" | translate }}
        </div>
        <div
          *ngIf="
             signupForm?.errors?.['confirmPasswordValidator']
          "
          class="input-error-message"
        >
          {{ "@pages.signup.form.errors.passwordsNotMatch" | translate }}
        </div>
      </div>
      <div class="form-item">
        <app-dropdown
          [control]="signupForm.controls.locationHash"
          [iconName]="'store'"
          [label]="'@pages.signup.form.location.label' | translate"
          [placeholder]="'@pages.signup.form.location.placeholder' | translate"
          [isMarkedAsRequired]="true"
          [model]="locationDropdownModel"
        ></app-dropdown>
        <div
          *ngIf="
            signupForm.controls.locationHash.touched &&
            !signupForm.controls.locationHash.value
          "
          class="input-error-message"
        >
          {{ "@pages.signup.form.errors.locationEmpty" | translate }}
        </div>
      </div>
      <div class="form-item">
        <app-input
          [control]="signupForm.controls.registrationCompanyCode"
          [iconName]="'company'"
          [label]="
            '@pages.signup.form.registrationCompanyCode.label' | translate
          "
          [placeholder]="
            '@pages.signup.form.registrationCompanyCode.placeholder' | translate
          "
          [isMarkedAsRequired]="false"
          [inputType]="'number'"
        ></app-input>
      </div>
      <div class="language-selector">
        <app-language-selector></app-language-selector>
      </div>
      <div class="agreements">
        <div class="agreement-item">
          <input
            type="checkbox"
            [checked]="termsOfUseAgreementControl.value === true"
            (click)="
              termsOfUseAgreementControl.setValue(
                !termsOfUseAgreementControl.value
              )
            "
            class="app-checkbox"
          />
          <span class="text">{{
            "@pages.signup.agreements.termsOfUse.text" | translate
          }}</span>
        </div>
      </div>
    </div>
    <div class="action-btn">
      <app-action-button
        (click)="onSignupButtonClick()"
        [label]="'@pages.signup.actionBtn' | translate"
        [endIconName]="'arrow-right'"
        [disabled]="
          signupForm.invalid ||
          signupForm.untouched ||
          termsOfUseAgreementControl.value !== true
        "
        [isLoading]="(loader.isLoading$ | async)!"
      ></app-action-button>
    </div>
    <div (click)="onAlreadyHaveAccountClick()" class="already-have-account">
      {{ "@pages.signup.alreadyHaveAccount" | translate }}
    </div>
    <div (click)="onOpenPolicyLink()" class="dont-have-account">
      {{ "@pages.login.policyLink" | translate }}
    </div>
    <div (click)="onOpenTermsOfUseLink()" class="link">
      {{ "@pages.login.termsOfUseLink" | translate }}
    </div>
    <div (click)="onOpenImprintLink()" class="link">
      {{ "@pages.login.imprintLink" | translate }}
    </div>
  </div>
</div>
